import type { ImageSource } from './types';
import type { FC, ProviderProps } from 'react';

import { createContext, useContext } from 'react';

export interface TileImageContextProps {
  primaryImage: ImageSource | null;
  hoverImage: ImageSource | null;
}

const TileImageContext = createContext<TileImageContextProps | undefined>(undefined);

export const useTileImageContext = () => {
  const context = useContext(TileImageContext);

  if (context === undefined) {
    throw new Error('`useTileImageContext` is used outside of an `<TileImageProvider />');
  }

  return context;
};

export const TileImageProvider: FC<ProviderProps<TileImageContextProps>> = ({
  children,
  value,
}) => <TileImageContext.Provider value={value}>{children}</TileImageContext.Provider>;
